declare namespace $ {

	export class $mol_icon_content_save extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=save.view.tree.d.ts.map